import React from "react";
import Build from "./Build";

const index = () => {
  return (
    <div>
      <Build />
    </div>
  );
};

export default index;
